import type { CursorPagination, CursorPaginationParams } from './base'

export interface Customer {
  companyOrgNumber?: string
  companyName?: string
  companyAddress?: string
  companyZipCode?: string
  companyAddressCity?: string
  companyEmail?: string
  companyPhone?: string
  companyCountry?: string
  driverID?: string
  driverFirstName?: string
  driverLastName?: string
  driverEmail?: string
  driverPhoneNumber?: string
  driverAddress?: string
  driverNo?: number
  driverExternalNumber?: string
  driverISWarrantyDriver?: boolean
  driverZipCode?: string
  driverAddressCity?: string
  driverCountry?: string
  driverStatus?: TypeCustomerStatus
  driverGDPRAccept?: boolean
  driverAcceptsMarketing?: boolean
  driverHasCard?: boolean
  driverCardNumber?: string
  driverCardValidTo?: string
  driverKeyNumber?: string
  driverNotesShared?: string
  driverNotes?: string
  createdAt?: string
  updatedAt?: string
  orgID?: string
  firstName?: string
  lastName?: string
}

export interface CustomerListParams extends CursorPaginationParams {
  orgID: string
}

export interface CustomerListData extends CursorPagination {
  drivers: Customer[]
}

export interface CustomerPayload {
  driver: Partial<Customer>
  cars: string[]
}

export enum CustomerStatus {
  active = 'Active',
  inactive = 'Inactive',
  blacklisted = 'Blacklisted',
}

export type TypeCustomerStatus = 'Active' | 'Inactive' | 'Blacklisted'
